module.exports = __webpack_public_path__ + "img/outfield-picnic-pavilion-05.69647dda.jpeg";